import { Component, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

import * as L from 'leaflet';

import { LeafletMap } from '../../lib/maps/leaflet-map';
import { LeafletMapSettings } from '../../lib/maps/leaflet-map-settings';
import { Location } from '../../lib/maps/location';
import { TileServerSettings } from '../../lib/maps/tile-server-settings';
import { SettingsService } from '../../lib/services/settings';
import { LeafletMapOptions } from '../../lib/maps/leaflet-map-options';
import { Geocode } from '../../services/pharmacy-locator/models/geocode';
import { LeafletEvent } from 'leaflet';


@Component({
    selector: 'pdmi-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.css']
})
export class MapComponent implements AfterViewInit {
    constructor(private settings: SettingsService) {
        this.mapSettings = this.settings.mapSettings;
        this.tileServerSettings = this.settings.tileServerSettings;
    }

    // region Properties
    @Input()
    locations: Array<Location>;
    @Input()
    mapSize = 600;
    @Input()
    targetCenter: any;

    @Output()
    centerChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    markerClicked: EventEmitter<LeafletEvent> = new EventEmitter<LeafletEvent>();
    @Output()
    zoomChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    currentCenter = L.latLng([40.989, -80.630]);

    get mapBounds() {
        const mapBounds = this.leafletMap.map.getBounds();
        const northWest = mapBounds.getNorthWest();
        const southEast = mapBounds.getSouthEast();
        return {
            BottomRight: new Geocode(southEast.lat, southEast.lng),
            UpperLeft: new Geocode(northWest.lat, northWest.lng)
        };
    }

    leafletMap: LeafletMap;
    mapSettings: LeafletMapSettings;
    tileServerSettings: TileServerSettings;

    // endregion
    ngAfterViewInit(): void {
        this.mapSettings.mapOptions = this.mapSettings.mapOptions || new LeafletMapOptions();
        this.mapSettings.mapOptions.center = this.currentCenter;
        this.leafletMap = new LeafletMap('mapComponent', this.mapSettings, this.tileServerSettings);

        this.leafletMap.on('moveend',
            e => {
                this.centerChanged.emit(true);
            });

        this.leafletMap.on('zoomend',
            e => {
                this.zoomChanged.emit(true);
            });

        this.leafletMap.on('markerClick',
            e => {
                this.markerClicked.emit(e);
            });
    }

    // region Methods
    addHomeMarker = (location: Location, icon: L.Icon): void => this.leafletMap.addMarker(location, icon, "You are here!");
    addLocationMarker = (location: Location, icon: L.Icon): void => this.leafletMap.addMarker(location, icon);
    getCenter = (): any => this.leafletMap.getCenter();
    getZoom = (): number => this.leafletMap.getZoom();
    setView = (center: L.LatLng, zoom: any, options?: L.ZoomPanOptions): void => {
        this.leafletMap.setView(center, zoom, options);
    };
    zoomOut = (): void => this.leafletMap.zoomOut();
    showPopup = (id: string): void => this.leafletMap.showPopup(id);
    updateLocations(locations: Array<Location>): void {
        this.locations = locations;
        for (const location of this.locations) {
            this.addLocationMarker(location, this.settings.mapSettings.markerIcon);
        }
    }
    // endregion
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/map/map.component.ts